import { Component, Input, OnInit, ViewChild } from '@angular/core';

import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";

import { DeleteDialogComponent } from "../../common-ui/delete-dialog/index";
import { MatDialog } from '@angular/material/dialog';
import { SnackService } from '../../services';
import { ProviderService } from '../../api';
import { ActivatedRoute } from '@angular/router';
import { DecryptFormatPipe } from '../../pipes';


@Component({
  selector: 'school-customized-availability-lists',
  templateUrl: './customized-availability-lists.component.html',
  styleUrls: ['./customized-availability-lists.component.scss'],
  providers:[DecryptFormatPipe]
})
export class CustomizedAvailabilityListsComponent implements OnInit {


  @Input() AvailabilityIconPath: string;
  @Input() EditIconPath: string;
  @Input() DeleteIconPath: string;
  @Input() PageSize_Options: any;
  @Input() Page_Size: any;
  @Input() user_id: any;
  @Input() action: any = { Edit: true, Create: true };

  @ViewChild(MatPaginator)
  paginator: MatPaginator;
  @ViewChild(MatSort)
  sort: MatSort;
  isCreateAvailability = false;

  maxdate: any = new Date();
  filterdata: string;
  from_date: any;
  fromdate: any;
  todate: any;
  orderby: string;
  direction: string;

  editicon: string;
  deleteicon: string;

  Page_Index: number;
  totalLength: number;
  last_page: number;
  FormStatus: boolean = false;
  AccFormtype = "accordion";

  paginatorIndex: any;
  availabilityId: number;
  availability: string;
  unit: string;
  availabilityFlagColor: string;
  availabilitydate: Date;

  thisnow = new Date();
  todayDate = (this.thisnow.getMonth() + 1) + "/" + this.thisnow.getDate() + "/" + this.thisnow.getFullYear();


  availability_displayedColumns: string[] = [
      "id",
      "date",
      "timing",
      "actions",
  ];

  availabilitydataSource = new MatTableDataSource;

  constructor(
      private dialog: MatDialog,
      private route: ActivatedRoute,
      private _decryptPipe: DecryptFormatPipe,
      private _snackService: SnackService,
      private _userService: ProviderService,) {

       }

  ngOnInit(): void {
      this.availabilitydataSource.paginator = this.paginator;
      this.availabilitydataSource.sort = this.sort;
      this.editicon = this.EditIconPath;
      this.deleteicon = this.DeleteIconPath;

      this.user_id = this.user_id?(this.user_id).replace(/['"]+/g, ''): '';
      this.paginatorIndex = {
          pageIndex: 0,
          pageSize: this.Page_Size,
          active: "id",
          direction: "desc"
      };
  }

  exp_Accordion(value): void {

      if (value && !this.isCreateAvailability) {
          this.getAvailabilityList(this.paginatorIndex);
      }
  }
  val: any = [];



  applyFilter(from: Date, to: Date) {


      this._snackService.openSnackBar("Info", "Filtering....");

      this.fromdate = from;
      this.todate = to;

      this.getAvailabilityList(this.paginatorIndex);
      this.paginator.firstPage();

  }



  showcreateAvailability(actionType, availability_id) {

      this.isCreateAvailability = true;

      if (actionType == "update") {
          this.FormStatus = true;
          this.availabilityId = availability_id;
      }
      else {
          this.FormStatus = false;
          this.availabilityId = availability_id;
      }
  }


  showAvailabilitylist() {
      this.isCreateAvailability = false;
      this.FormStatus = false;
      this.getAvailabilityList(this.paginatorIndex);
  }

  getAvailabilityList(event): void {

      event.active = this.orderby ? this.orderby : "from_date";
      event.direction = this.direction ? this.direction : "desc";
      event.fromdate = this.fromdate ? this.fromdate : "";
      event.todate = this.todate ? this.todate : "";
      event.user_id = this.user_id ? this.user_id : "";

      this.Page_Index = event.pageIndex + 1;
      this._userService.getCustomizedavailabilityList(event).subscribe(
          result => {
              this.availabilitydataSource = new MatTableDataSource(result.body.data.custom_availability_details);
              this.totalLength = result.body.data.pagination.total;
              this.Page_Size = result.body.data.pagination.per_page;
              this.last_page = result.body.data.pagination.last_page;
              var Pageoptions = new Array();
              for (let i = 1; i <= this.last_page; i++) {
                  Pageoptions.push(result.body.data.pagination.per_page * i);
              }
              this.PageSize_Options = Pageoptions;

          }, error => {
              console.log(error);
          });

  }


  deleteAvailability(id: string): void {

      const dialogRef = this.dialog.open(DeleteDialogComponent, {
          width: '450px',
          data: {
              message: 'Are you sure want to delete?',
              deleteId: id,
              buttonText: {
                  ok: 'Yes',
                  cancel: 'No'
              }
          }
      });


      dialogRef.afterClosed().subscribe((res: any) => {
          if (res) {

              this._userService.deleteCustomizedavailability(res['deleteId']).subscribe(
                  result => {

                      this._snackService.openSnackBar("success", "Availability Deleted Successfully!...");
                      this.getAvailabilityList(this.paginatorIndex);


                  }, error => {
                      this._snackService.openSnackBar("danger", "Failed to Delete Availability!...");
                  });

          }
      });


  }

}
